import React from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";

// Shell do layout PÚBLICO (sem autenticação): header no mesmo padrão do app
// (logo à esquerda) + botão Login à direita, e footer. O conteúdo vai em children.
export default function PublicShell({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="flex items-center justify-between border-b border-border bg-card z-50">
        <Link to="/landing" className="flex w-52 items-center justify-center border-r border-border px-4 py-3">
          <img
            src="/assets/stratasec_light.png"
            alt="SecurityScan"
            className="h-7 w-auto drop-shadow-[0_0_10px_rgba(255,255,255,0.4)]"
          />
        </Link>
        <div className="px-6 py-3">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            <LogIn size={16} />
            Login
          </Link>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-border px-6 py-4 text-center text-xs text-muted-foreground">
        &copy; Sec4US 2026 · SecurityScan
      </footer>
    </div>
  );
}
